import * as actions from './actions';

import { merge } from 'lodash';
import { ActionType, getType } from 'typesafe-actions';

export interface IPagesHistoryHomeState {
  readonly quoteMessageId: any;
  readonly quoteLastSeenDate: any;
}

export const initialState: IPagesHistoryHomeState = {
  quoteMessageId: null,
  quoteLastSeenDate: null,
};

type HistoryHomeActions = ActionType<typeof actions>;

export default (
  state: Mutable<IPagesHistoryHomeState> = initialState,
  action: HistoryHomeActions,
): IPagesHistoryHomeState => {
  switch (action.type) {
    case getType(actions.updatePagesHistoryHomeQuoteLastSeenDate): {
      state.quoteLastSeenDate = action.payload;
      break;
    }
    case getType(actions.updatePagesHistoryHomeQuoteMessageId): {
      state.quoteMessageId = action.payload;
      break;
    }
    case getType(actions.updatePagesHistoryHomeStateFromExternalSource): {
      return merge({ ...state }, action.payload);
    }
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryHome/reducer.ts